export enum ClientPageTabs {
    DEFAULT = 1,
    ORGANOGRAM_CUTOUT,
    NEWS_ORIGIN,
    TAGS,
    DASHBOARD,
    SOCIAL_MEDIA
}